/* Move the existing nodes on mobile; comment markers restore the exact desktop DOM. */
if (!customElements.get('mobile-product-layout')) {
  customElements.define('mobile-product-layout', class extends HTMLElement {
    connectedCallback() {
      this.page = document.getElementById(`ProductPage-${this.dataset.sectionId}`);
      this.info = this.page?.querySelector('.product-info');
      if (!this.info) return;
      this.query = window.matchMedia('(max-width: 989px)');
      this.onViewportChange = () => {
        if (this.query.matches && !this.mobile) this.enableMobile();
        if (!this.query.matches && this.mobile) this.restoreDesktop();
      };
      this.query.addEventListener('change', this.onViewportChange);
      this.onViewportChange();
    }

    move(node, parent, before = null) {
      if (!node || !parent) return;
      const marker = document.createComment('mobile-product-original-position');
      node.before(marker);
      this.moves.push({ node, marker });
      parent.insertBefore(node, before);
    }

    accordion(node, heading, destination) {
      if (!node) return;
      const wrapper = document.createElement('details');
      wrapper.className = 'mobile-product-accordion';
      const summary = document.createElement('summary');
      summary.textContent = heading;
      wrapper.appendChild(summary);
      if (destination) destination.appendChild(wrapper);
      else node.before(wrapper);
      wrapper.open = node.contains(document.activeElement);
      this.wrappers.push(wrapper);
      this.move(node, wrapper);
    }

    enableMobile() {
      this.mobile = true;
      this.moves = [];
      this.wrappers = [];
      const focused = document.activeElement;
      const title = this.info.querySelector('.product-info-main');
      const next = title ? title.nextSibling : this.info.firstChild;
      for (const selector of [
        '.product-info-purchase-price',
        '.product-info-purchase-variants',
        '.product-info-purchase-actions',
      ]) this.move(this.page.querySelector(selector), this.info, next);

      const actions = this.page.querySelector('.product-info-purchase-actions');
      const form = actions?.querySelector('product-form');
      const guidance = actions?.querySelector('.purchase-guidance');
      if (form) this.move(guidance, actions, form);

      this.description = this.info.querySelector('.description__content');
      if (this.description) {
        this.accordion(this.description, this.description.dataset.mobileHeading || 'Description');
      }
      for (const details of this.page.querySelectorAll('.product-info-details')) {
        const heading = details.querySelector('.product-info-details-title')?.textContent.trim();
        this.accordion(details, heading || 'Product details');
      }

      const lower = this.page.querySelector('.product-info-description-content');
      this.recommendations = this.page.querySelector('#product-recommendations-sidebar');
      this.move(this.recommendations, lower);
      const tabs = this.page.querySelector('.product-info-tabs-col');
      if (tabs) this.accordion(actions?.querySelector('.stubhub-btn-wrap'), 'Concert tickets', tabs);
      if (focused?.isConnected && this.page.contains(focused)) focused.focus({ preventScroll: true });
    }

    restoreDesktop() {
      const focused = document.activeElement;
      for (const { node, marker } of this.moves.reverse()) marker.replaceWith(node);
      for (const wrapper of this.wrappers) wrapper.remove();
      this.moves = [];
      this.wrappers = [];
      this.mobile = false;
      // The original desktop script places recommendations immediately after the description.
      if (this.description && this.recommendations) this.description.after(this.recommendations);
      if (focused?.isConnected && this.page.contains(focused)) focused.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this.query?.removeEventListener('change', this.onViewportChange);
      if (this.mobile) this.restoreDesktop();
    }
  });
}
